import {
    Compass,
    Megaphone,
    Inbox,
    Sparkles,
    MailCheck,
    Target,
    TrendingUp,
    RefreshCw,
} from "lucide-react";
import { Reveal } from "./Reveal";

const steps = [
    { icon: Compass, label: "Strategy" },
    { icon: Megaphone, label: "Advertising" },
    { icon: Inbox, label: "Enquiry" },
    { icon: Sparkles, label: "AI Qualification" },
    { icon: MailCheck, label: "Follow-Up" },
    { icon: Target, label: "Sales Opportunity" },
    { icon: TrendingUp, label: "Revenue" },
    { icon: RefreshCw, label: "Reinvestment" },
];

export const Process = () => (
    <section
        id="how-it-works"
        data-testid="process-section"
        className="scroll-mt-16 bg-[#F8FAFC] py-24 lg:py-32"
    >
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <Reveal>
                <p className="text-sm font-semibold uppercase tracking-wider text-[#2563EB]">
                    How FlowPilot Works
                </p>
                <h2 className="mt-3 max-w-2xl text-3xl font-bold tracking-tight text-[#0B1F44] lg:text-4xl">
                    One connected system, from first click to reinvested pound.
                </h2>
            </Reveal>
            <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                {steps.map((s, i) => (
                    <Reveal key={s.label} delay={i * 0.06}>
                        <div
                            data-testid={`process-step-${i}`}
                            className="fp-card-shadow group relative flex h-full flex-col rounded-2xl border border-gray-100 bg-white p-6 transition-all hover:-translate-y-1"
                        >
                            <span className="text-xs font-semibold tracking-wider text-[#60A5FA]">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <span className="mt-4 flex h-11 w-11 items-center justify-center rounded-xl bg-[#2563EB]/10 transition-colors group-hover:bg-[#2563EB]">
                                <s.icon className="h-5 w-5 text-[#2563EB] transition-colors group-hover:text-white" />
                            </span>
                            <p className="mt-4 text-base font-semibold text-[#0B1F44]">
                                {s.label}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
            <Reveal delay={0.2}>
                <p className="mt-10 text-center text-sm text-[#6B7280]">
                    Strategy &rarr; Advertising &rarr; Enquiry &rarr; AI
                    Qualification &rarr; Follow-Up &rarr; Sales Opportunity
                    &rarr; Revenue &rarr; Reinvestment
                </p>
            </Reveal>
        </div>
    </section>
);
